import { Navigate } from 'react-router-dom';

import { NFC_CARDS_PATH } from 'lib/nfcCardScreens';

import useLoggedUser from 'hooks/useLoggedUser';
import { UsersTypes } from 'types/global';

import Dashboard from 'components/screens/Dashboard';

/**
 * The landing screen. An NFC admin only manages cards, and the dashboard reads what that
 * role cannot (the shortcuts), so it lands on the cards instead.
 */
function Home() {
	const user = useLoggedUser();

	if (user?.type === UsersTypes.nfcAdmin) {
		return <Navigate to={NFC_CARDS_PATH} replace />;
	}

	return <Dashboard />;
}

export default Home;
